module.exports = __webpack_public_path__ + "img/dementia-03-risk-factor.64c40bde.jpg";